export const documentConstants = {   
    GET_CRITERIA_SUCCESS: 'DOCUMENT_GET_CRITERIA_SUCCESS',
    GET_CRITERIA_FAILURE: 'DOCUMENT_GET_CRITERIA_FAILURE',
    GET_DOCUMENT_REQUEST: 'GET_DOCUMENT_REQUEST',
    GET_DOCUMENT_SUCCESS: 'GET_DOCUMENT_SUCCESS',
    GET_DOCUMENT_FAILURE: 'GET_DOCUMENT_FAILURE',
    DOCUMENT_FIELDS: 'DOCUMENT_TABLE_FIELDS',
    RENDER_RESULTS: 'RENDER_RESULTS'
}